import React from "react";
import { Platform } from "react-native";
import { View, StyleSheet } from "react-native";
import { ToggleButton, Text, typography, theme } from "ui-components";

interface ToggleEmailPreferencesProps {
  title?: string;
  onValueChange?: any;
  value: boolean;
  testID?: string;
  accessibilityLabel?: string;
  disabled?: boolean;
}
export const ToggleEmailPreferences = (props: ToggleEmailPreferencesProps) => {
  const { title, onValueChange, value, testID, accessibilityLabel, disabled } = props;
  return (
    <View
      style={styles.container}
      testID={`${testID}-container`}
      accessibilityLabel={`${accessibilityLabel} container`}>
      <Text
        style={styles.title}
        testID={`${testID}-title`}
        accessibilityLabel={`${accessibilityLabel} title`}>
        {title}
      </Text>
      <ToggleButton
        onValueChange={onValueChange}
        value={value}
        testID={`${testID}-toggle-button`}
        accessibilityLabel={`${accessibilityLabel} toggle button`}
        disabled={disabled}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingLeft: 24,
    paddingRight: 22,
    backgroundColor: Platform.OS == "web" ? theme.colors.white : "#F3F3F3",
  },
  title: {
    ...typography.title2,
    flex: 1,
    color: theme.colors.text3,
  },
});
